/**
 * Mounts whichever of the six modals `store.modal` selects. Each modal
 * self-gates on `open` (it reads `store.modal` itself and renders `null`
 * otherwise), so mounting all six here is cheap and the "only one modal
 * open at a time" invariant lives in the store's single `modal` field, not
 * in this component.
 *
 * A later task wires this into the console shell (README §1) — nothing
 * under apps/console/src/App.tsx or src/pages/** is touched by this task,
 * per the brief's file-scope constraint.
 */
import { TicketModal } from './TicketModal'
import { MatchModal } from './MatchModal'
import { OtpModal } from './OtpModal'
import { HandoffModal } from './HandoffModal'
import { CloseModal } from './CloseModal'
import { ComposeModal } from './ComposeModal'

export function ModalRoot() {
  return (
    <>
      <TicketModal />
      <MatchModal />
      <OtpModal />
      <HandoffModal />
      <CloseModal />
      <ComposeModal />
    </>
  )
}
